module.exports = __webpack_public_path__ + "img/02.14c34956.png";